export const SET_SA='SET_SA'
export const SET_CLIENT_ID='SET_CLIENT_ID'